module.exports = __webpack_public_path__ + "img/mini.3e127837.png";